module.exports = __webpack_public_path__ + "img/jade-city.48dc348a.png";